import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Moderntechnology({ handleShow }) {
  return (
    <section className="modern_technology p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>
              Modern, Tech-Driven Solutions for{" "}
              <span>Innovators & Disruptors</span>
            </h2>
            <p>
              Our suite of mobile app development services in the UK uplifts
              your business's online presence and breaks into new growth
              opportunities. Using high-end technologies, our app developers in
              the UK create digital experiences that captivate your audience,
              boost engagement, and foster loyalty. We continually adapt to
              emerging technologies to help you lead the industry with
              innovative, future-ready mobile solutions.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="modern_box">
              <div className="modern_box_item">
                <div className="modern_icon">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/technology/ar_vr.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={68}
                  />
                </div>
                <div className="modern_head">
                  <h5>AR/ VR</h5>
                </div>
              </div>
              <div className="modern_content">
                <p>
                  Our mobile app developers in the UK deliver immersive AR/VR
                  solutions, blending digital and real worlds for enhanced user
                  engagement.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="modern_box">
              <div className="modern_box_item">
                <div className="modern_icon">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/technology/block_chain.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={68}
                  />
                </div>
                <div className="modern_head">
                  <h5>Block Chain</h5>
                </div>
              </div>
              <div className="modern_content">
                <p>
                  We develop secure, decentralised apps using blockchain to
                  boost transparency and trust in finance, supply chain, and
                  healthcare.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="modern_box">
              <div className="modern_box_item">
                <div className="modern_icon">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/technology/staff_aug.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={68}
                  />
                </div>
                <div className="modern_head">
                  <h5>Staff Augmentation</h5>
                </div>
              </div>
              <div className="modern_content">
                <p>
                  We provide skilled app developers to enhance your team,
                  accelerating project timelines and ensuring budget compliance.
                </p>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="modern_box">
              <div className="modern_box_item">
                <div className="modern_icon">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/technology/ai.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={68}
                  />
                </div>
                <div className="modern_head">
                  <h5>Artificial Intelligence</h5>
                </div>
              </div>
              <div className="modern_content">
                <p>
                  Our AI solutions automate tasks and deliver insights,
                  improving decision-making and efficiency across industries.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="modern_box">
              <div className="modern_box_item">
                <div className="modern_icon">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/technology/iot.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={68}
                  />
                </div>
                <div className="modern_head">
                  <h5>Internet of Things</h5>
                </div>
              </div>
              <div className="modern_content">
                <p>
                  We create smart IoT solutions to connect devices, automate
                  processes, and enhance user control and convenience.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
            <div className="modern_box">
              <div className="modern_box_item">
                <div className="modern_icon">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/technology/fintech.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={68}
                    height={68}
                  />
                </div>
                <div className="modern_head">
                  <h5>Fintech</h5>
                </div>
              </div>
              <div className="modern_content">
                <p>
                  Our fintech solutions streamline financial processes, enhance
                  security, and elevate customer experiences in the financial
                  sector.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <button
              onClick={handleShow}
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Build Future-Ready Mobile App
            </button>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Moderntechnology;
